// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"304":"19d298fc","453":"1ace393f"}[chunkId] + ".chunk.js";
};